




import { Component, Prop, Vue } from 'vue-property-decorator';

import { Chart, PluginServiceRegistrationOptions } from 'chart.js';

@Component
export default class LabeledDonutChart extends Vue {
  @Prop(String) private readonly title!: string;
  @Prop(Number) private readonly percentage!: number;
  @Prop(String) private readonly label!: string;

  private mounted() {
    this.createChart();
  }

  private createChart() {
    const text = this.label;

    const plugin: PluginServiceRegistrationOptions = {
      beforeDraw(chart) {
        if (chart === null ||
          chart.canvas === null ||
          chart.ctx === null ||
          chart.config === undefined ||
          chart.config.options === undefined ||
          chart.config.options.title === undefined ||
          chart.config.options.title.fontSize === undefined) {
          return;
        }

        // Take device pixel ratio into account so that the text is correctly positioned on high DPI displays
        const width = chart.canvas.width / window.devicePixelRatio;
        const height = chart.canvas.height / window.devicePixelRatio;

        const ctx = chart.ctx;
        const titleFontSize = chart.config.options.title.fontSize;

        ctx.restore();
        const labelFontSize = (height / 100).toFixed(2); // 100 is a magic number
        ctx.font = labelFontSize + 'em sans-serif';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = '#b33d47';

        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = (height / 2) - (titleFontSize * 0.8); // 0.8 is a magic number

        ctx.fillText(text, textX, textY);
        ctx.save();
      },
    };

    const canvas = this.$refs.chartCanvas as HTMLCanvasElement;
    const context = canvas.getContext('2d')!;
    const data = {
      datasets: [{
        data: [this.percentage, 100 - this.percentage],
        backgroundColor: [
          '#b33d47',
          '#e9eaeb',
        ],
      }],
    };
    // tslint:disable-next-line no-unused-expression
    new Chart(context, {
      plugins: [plugin],
      type: 'doughnut',
      data,
      options: {
        events: [],
        cutoutPercentage: 80,
        title: {
          display: true,
          fontSize: 18,
          text: this.title,
          position: 'bottom',
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
    });
  }
}
